import { useEffect, useMemo } from 'react';
import { useRecoilState } from 'recoil';

import { useFeatureToggleState } from '@/context';
import { useErrorHandler, useGlobal } from '@/hooks';
import { loadFeatureToggleService } from '@/services';

import { UseFeatureToggleProps } from './types';

export const useFeatureToggle = ({ featureName }: UseFeatureToggleProps) => {
  const global = useGlobal();
  const [state, setState] = useRecoilState(useFeatureToggleState);
  const errorHandler = useErrorHandler();

  const loadFeatureToggle = () => {
    loadFeatureToggleService()
      .then((features) => setState((old) => ({ ...old, features, isLoaded: true })))
      .catch(errorHandler)
      .finally(() => setState((old) => ({ ...old, isLoading: false })));
  };

  const fillFeatures = () => {
    if (global?.features?.isFetched) setState((old) => ({ ...old, features: global.features.data, isLoaded: true }));
    else if (!state.isLoaded) loadFeatureToggle();
  };

  const isOnTheFeatureToggle = useMemo(
    () => state.features.some(({ feature }) => feature === featureName),
    [state.features]
  );

  useEffect(fillFeatures, []);

  return { featureToggleState: state, isOnTheFeatureToggle };
};
